import { gql, useQuery } from '@apollo/client';
import {
  ArticleFilterSearchInput,
  GetArticlesQuery_query_publishedArticles_Article,
  GetArticlesQuery_query_scheduledArticles_Article,
  GetArticlesQueryVariables,
} from '__generated__/queries-web';
import { ARTICLE_FRAGMENT } from '../fragments/article.web.graphql';

export const GET_ARTICLES = gql`
  query GetArticles(
    $first: UnsignedInt!
    $orderBy: [ArticleOrderingSearchInput!]
    $skip: UnsignedInt
    $wherePublishedArticles: ArticleFilterSearchInput
    $whereScheduledArticles: ArticleFilterSearchInput
    $whereScheduledForRepublicationArticles: ArticleFilterSearchInput
  ) {
    publishedArticles: searchArticles(
      first: $first
      orderBy: $orderBy
      skip: $skip
      where: $wherePublishedArticles
    ) {
      ...article
    }
    scheduledArticles: searchArticles(
      first: $first
      orderBy: $orderBy
      skip: $skip
      where: $whereScheduledArticles
    ) {
      ...article
    }
    scheduledForRepublicationArticles: searchArticles(
      first: $first
      orderBy: $orderBy
      skip: $skip
      where: $whereScheduledForRepublicationArticles
    ) {
      ...article
    }
  }
  ${ARTICLE_FRAGMENT}
`;

interface GetArticlesWithAliases {
  publishedArticles: GetArticlesQuery_query_publishedArticles_Article[];
  scheduledArticles: GetArticlesQuery_query_scheduledArticles_Article[];
  scheduledForRepublicationArticles: GetArticlesQuery_query_scheduledArticles_Article[];
}

interface GetArticlesVariablesWithAliases extends GetArticlesQueryVariables {
  wherePublishedArticles: ArticleFilterSearchInput | null;
  whereScheduledArticles: ArticleFilterSearchInput | null;
  whereScheduledForRepublicationArticles: ArticleFilterSearchInput | null;
}

export const useGetArticles = (
  variables: GetArticlesVariablesWithAliases,
  skip?: boolean,
) =>
  useQuery<GetArticlesWithAliases, GetArticlesVariablesWithAliases>(
    GET_ARTICLES,
    {
      variables,
      skip,
      notifyOnNetworkStatusChange: true,
    },
  );
